const mapOptions = {
  fullscreenControl: true,
  disableDefaultUI: true,
  keyboardShortcuts: false,
  zoomControl: true,
};

export { mapOptions };
